export var Step;
(function (Step) {
  Step["SendEmail"] = "sendEmail";
  Step["ValidateCode"] = "validateCode";
})(Step || (Step = {}));